import React, { useState } from "react";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import { addMovementToLift, updateLift, getLiftById } from "../firebase/firestore";

const Movement = () => {
  const { liftId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { movementIndex, movementData } = location.state || {}; // Retrieve state
  const [movement, setMovement] = useState(
    movementData || { name: "", sets: 0, reps: 0, weight: 0, weightType: "", completed: false }
  );

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setMovement({ ...movement, [name]: type === "checkbox" ? checked : value });
  };

  const handleWeightTypeChange = (e) => {
    setMovement({ ...movement, weightType: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (movementIndex !== undefined) {
        // Editing an existing movement
        const liftData = await getLiftById(liftId);
        const updatedMovements = [...liftData.movements];
        updatedMovements[movementIndex] = movement;
        await updateLift(liftId, { movements: updatedMovements });
      } else {
        // Adding a new movement
        await addMovementToLift(liftId, movement);
      }
      navigate(`/lift/${liftId}`);
    } catch (error) {
      console.error("Error saving movement:", error);
    }
  };

  return (
    <div className="movement-container">
      <h1>{movementIndex !== undefined ? "Edit Movement" : "Add Movement"}</h1>
      <form onSubmit={handleSubmit} className="movement-form">
      <label>
          <input
            type="checkbox"
            name="completed"
            checked={movement.completed}
            onChange={handleInputChange}
          />
        </label>
        <label>
          Movement Name:
          <input
            type="text"
            name="name"
            value={movement.name}
            onChange={handleInputChange}
            required
          />
        </label>
        <label>
          Sets:
          <input
            type="number"
            name="sets"
            value={movement.sets}
            onChange={handleInputChange}
            required
          />
        </label>
        <label>
          Reps:
          <input
            type="number"
            name="reps"
            value={movement.reps}
            onChange={handleInputChange}
            required
          />
        </label>
        <label>
          Weight:
          <input
            type="number"
            name="weight"
            value={movement.weight}
            onChange={handleInputChange}
            required
          />
        </label>
        <fieldset>
          <legend>Weight Type:</legend>
          <div style={{ display: "flex", gap: "10px" }}>
            <label>
              <input
                type="radio"
                name="weightType"
                value="Dumbbells"
                checked={movement.weightType === "Dumbbells"}
                onChange={handleWeightTypeChange}
              />
              Dumbbells
            </label>
            <label>
              <input
                type="radio"
                name="weightType"
                value="Barbell"
                checked={movement.weightType === "Barbell"}
                onChange={handleWeightTypeChange}
              />
              Barbell
            </label>
            <label>
              <input
                type="radio"
                name="weightType"
                value="Bodyweight"
                checked={movement.weightType === "Bodyweight"}
                onChange={handleWeightTypeChange}
              />
              Bodyweight
            </label>
          </div>
        </fieldset>
        <button type="submit" className="submit-button">
          {movementIndex !== undefined ? "Save Changes" : "Add Movement"}
        </button>
        <button
          type="button"
          onClick={() => navigate(`/lift/${liftId}`)}
          className="cancel-button"
        >
          Cancel
        </button>
      </form>
    </div>
  );
};

export default Movement;
